export default "__VITE_ASSET__C3ca_gWW__"